import React from "react";
import FormalizerInputField from "../InputField";

type Props = {
    name: string;
};

const FormalizerTextareaField = ({ name, ...props }: Props) => {
    return (
        <div className="w-full" data-testid="form-textarea">
            <FormalizerInputField name={name} type="textarea" {...props} />
        </div>
    );
};

export default FormalizerTextareaField;
